/**
 * Onboarding Mode — Single source of truth for routing decisions.
 *
 * Routing is driven by whether the user has courses:
 *   has courses  → Dashboard-first
 *   no courses   → AI Tools-first
 *
 * The `has_courses` flag is persisted in the preferences blob so the
 * correct route is available immediately on login before data loads.
 */

const MODE_SYSTEM = 'system';
const MODE_TOOLS = 'tools';

/**
 * Read the onboarding mode from the preferences blob.
 * Returns "system", "tools", or null when preferences haven't loaded yet.
 */
export function getOnboardingMode(preferences) {
  if (!preferences) return null; // still loading — don't assume
  const mode = preferences.onboarding_mode;
  return mode === MODE_TOOLS ? MODE_TOOLS : MODE_SYSTEM;
}

/**
 * Determine whether to show tools-first or dashboard-first.
 *   has courses → false (dashboard-first)
 *   no courses  → true  (tools-first)
 *   unknown     → null  (still loading)
 */
export function isToolsFirst(preferences, hasCourses) {
  if (hasCourses || preferences?.has_courses) return false;
  if (!preferences) return null; // still loading
  return true;
}

/**
 * Return the default home route.
 *   has courses → /dashboard
 *   no courses  → /ai-tools
 *   unknown     → null (caller should wait)
 */
export function getDefaultHomeRoute(preferences, hasCourses) {
  const toolsFirst = isToolsFirst(preferences, hasCourses);
  if (toolsFirst === null) return null;
  return toolsFirst ? '/ai-tools' : '/dashboard';
}
